'use strict';
const angular = require('angular');

/*@ngInject*/
export function BusinessService($resource) {
  return $resource('/api/businesses/:id', {
    id: '@_id'
  },{
    patch: {
      method: 'PATCH'
    },
    update: {
      method: 'PUT'
    },
    queryVendors: {
      method: 'GET',
      url: "/api/businesses/vendor",
      isArray: true
    },
    queryUserBusinesses: {
      method: 'GET',
      url: "/api/businesses/user",
      isArray: true
    }
  });
}


export default angular.module('conduuApp.BusinessService', [])
  .factory('BusinessService', BusinessService)
  .name;



// WEBPACK FOOTER //
// ./client/services/business/business.service.js